module.exports = __webpack_public_path__ + "img/revert-stick.b6394931.svg";